import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { authorization, currentUser, legit, session } from "apex-legit-service";
import { all } from "redux-saga/effects";
import { routerMiddleware } from "connected-react-router";
import { ApexAuth } from "apex-ui-services";
import createRootReducer, { history } from "./rootReducer";
import { getAppConfigSetting } from "../utils";

const sagaMiddleware = createSagaMiddleware();

// all sagas are run from the rootSaga
function* rootSaga() {
  const apiUrl: string = getAppConfigSetting("legitApiUrl");
  yield all([
    ApexAuth.authorization.sagas.authorizationFlow(apiUrl),
    ApexAuth.legacyUrl.sagas.legacyUrlFlow(apiUrl),
    ApexAuth.loginSso.sagas.ssoLoginFlow(apiUrl),
    ApexAuth.loginType.sagas.loginTypeFlow(apiUrl),
    authorization.authorizeFlow(),
    currentUser.currentUserFlow(),
    legit.adoptExistingSessionFlow(),
    legit.loginFlow(),
    legit.logoutFlow(),
    session.createSessionFlow(),
    session.destroySessionFlow(),
  ]);
}

// eslint-disable-next-line
export default function () {
  const hasWindow = typeof window !== "undefined";
  const composeEnhancers: any = hasWindow
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;
  const store = createStore(
    createRootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
  );
  // run middlewares after creating store
  // run the root saga
  sagaMiddleware.run(rootSaga);

  return store;
}

export { history };
